import React from 'react';
import logo from './logo.png';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          We are the SchemeFlexers - schemin' & flexin'
        </p>
        <a
          className="App-link"
          href="https://github.com/schemeflex"
          target="_blank"
          rel="noopener noreferrer"
        >
          Stay tuned for updates
        </a>
      </header>
    </div>
  );
}

export default App;
